// React Library
import React, { useState, useRef, useEffect } from 'react'

// Helmet
import Helmet from 'react-helmet'

// React Router DOM
import { withRouter, useHistory } from 'react-router-dom'

// Content
import { show as content } from './UsersContent'

// Query Related
import QueryHelper from '../Queries/QueryHelper'
import { GET_USERS } from '../Queries/Queries'

// Mutation Related
import { DELETE_USER } from '../Mutations/Mutations'

// Utils
import AddIconButton from '../Utils/AddIconButton'
import RootGrid from '../Utils/RootGrid'
import SearchTextInput from '../Utils/SearchTextInput'

// Trie-Search Algorithm
import TrieSearch from 'trie-search'
import UsersAgGrid from './UsersAgGrid'

// Query Component
const ShowUsers = props => {
  return (
    <>
      <Helmet>
        <title>Users</title>
      </Helmet>
      <QueryHelper
        query={GET_USERS}
      >
        {({ data }) => {
          const { getUsers: { users } } = data

          // Some Formatting...
          const usersArray = users.map(user => {
            return {
              ...user,
              role: user.role ? user.role.key : '-',
              adcom: user.userSetting && user.userSetting.adcom,
              settingId: user.userSetting && user.userSetting.id
            }
          })

          // Render
          return (
            <ShowUsersTable
              users={usersArray}
            />
          )
        }}
      </QueryHelper>
    </>
  )
}

const ShowUsersTable = props => {
  const { users = [] } = props

  // History For Links
  const history = useHistory()

  // Hooks For Search Bar Functionality
  const [search, setSearch] = useState('')
  const [searchUser, setSearchUser] = useState(users)

  // Trie-Search To Look For The Following Fields...
  const ts = new TrieSearch(['name', 'email'], {
    idFieldOrFunction: 'id'
  })

  // The Array To Be Filtered (All Users In the DB)
  ts.addAll(users)

  // Trie-Search Logic
  const searchRef = useRef(search)
  useEffect(() => {
    if (searchRef.current !== search) {
      searchRef.current = search
      if (!search) {
        setSearchUser(users)
      } else {
        const foundUsers = ts.get(search, TrieSearch.UNION_REDUCER)
        setSearchUser(foundUsers)
      }
    }
  }, [search, users, ts])

  // Link Of The Update User Page
  const updateLink = 'update-user'

  return (
    <RootGrid>

      {/* Search Bar + Create Button */}
      <SearchTextInput
        autoFocus
        label='Search'
        style={{ maxWidth: 600, margin: '0 auto' }}
        onChange={e => {
          setSearch(e.target.value)
        }}
        value={search}
      >
        <AddIconButton
          onClick={() => history.push(content.createButton.link)}
          color='primary'
        >
          {content.createButton.name}
        </AddIconButton>
      </SearchTextInput>

      {/* Users Grid (Made By Us) */}
      <UsersAgGrid
        filteredArray={searchUser}
        mutation={DELETE_USER}
        objectNameKey1='name'
        type='User'
        updateLink={updateLink}
      />

    </RootGrid>
  )
}

export default withRouter(ShowUsers)
